import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const PauseConfigurationList = Loadable(
  lazy(() => import("features/notification/pause/components/List"))
);

const routes = {
  path: "pause",
  children: [{ path: "", element: <PauseConfigurationList /> }],
};

export default routes;
